import actionTypes from '../constants/action-types';

const isOpen = (state = false, action) => {
  if (action.type !== actionTypes.SET_OPEN) return state;

  return action.payload.value;
};

export default isOpen;
